export const APPLY_REQUESTS_BY_PERSON = "APPLY_REQUESTS_BY_PERSON";
export const LOADING_REQUESTS = "LOADING_REQUESTS";
export const ERROR_REQUESTS = "ERROR_REQUESTS";